"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.creditas = void 0;
var creditas = {
  name: 'Creditas',
  link: '/',
  colors: {
    active: 'fontNeutral90',
    font: 'fontNeutral60',
    background: 'backgroundWhite'
  },
  links: [{
    id: 'simule-credito',
    label: 'Simule seu Crédito',
    link: '',
    submenu: [{
      title: '',
      links: [{
        id: 'garantia-veiculo',
        label: 'Empréstimo com veículo em garantia',
        link: '/emprestimo/garantia-veiculo'
      }, {
        id: 'garantia-imovel',
        label: 'Empréstimo com imóvel em garantia',
        link: '/emprestimo/garantia-imovel'
      }, {
        id: 'consignado-privado',
        label: 'Empréstimo consignado',
        link: '/emprestimo/consignado-privado'
      }]
    }]
  }, {
    id: 'solucoes',
    label: 'Solucoes',
    link: '',
    submenu: [{
      title: 'Imóveis',
      links: 'home'
    }, {
      title: 'Carros',
      links: 'auto'
    }]
  }, {
    id: 'store',
    label: 'Store',
    link: '/store',
    submenu: [{
      links: 'store'
    }]
  }, {
    id: 'business',
    label: 'Empresas',
    link: '/beneficios',
    submenu: [{
      links: 'business'
    }]
  }]
};
exports.creditas = creditas;